<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="toTop"></div>
    <div class="all-header">
      <div class="final-nav">
        <!-- Logo图片居左 -->
        <div class="nav-logo">
          <img
            src="@/components/img/logoCN.png"
            alt="华胤Logo"
            class="logo-img"
            @click="tohomejp"
          />
        </div>

        <!-- 桌面导航居右 -->
        <el-menu
          v-if="!isMobile"
          key="desktop"
          class="desktop-nav"
          mode="horizontal"
          @select="handleSelect"
          text-color="#000000"
          active-text-color="#000000"
        >
          <el-menu-item index="home" @click="tohomejp" class="nav-item">
            <span class="oneItem">ホーム</span>
          </el-menu-item>

          <el-submenu index="about" class="nav-item">
            <template slot="title"
              ><span class="oneItem">会社情報</span></template
            >
            <el-menu-item index="gyhy1" @click="togyhyjp1">
              <span class="twoItem">沿革</span></el-menu-item
            >
            <el-menu-item index="gyhy2" @click="togyhyjp2"
              ><span class="twoItem">企業理念</span></el-menu-item
            >
            <el-menu-item index="gyhy3" @click="togyhyjp3"
              ><span class="twoItem">ビジョン</span></el-menu-item
            >
            <el-menu-item index="gyhy4" @click="togyhyjp4"
              ><span class="twoItem">環境・社会・ガバナンス</span></el-menu-item
            >
            <el-menu-item index="gyhy5" @click="togyhyjp5"
              ><span class="twoItem">工場紹介</span></el-menu-item
            >
            <el-menu-item index="gyhy6" @click="togyhyjp6"
              ><span class="twoItem">国際認証と建築賞</span></el-menu-item
            >
          </el-submenu>

          <el-submenu index="product" class="nav-item">
            <template slot="title"
              ><span class="oneItem">技術・製品</span></template
            >
            <el-menu-item index="cpyfw1" @click="tocpyfwjp1"
              ><span class="twoItem"
                >エンジニアリングサービス</span
              ></el-menu-item
            >
            <el-menu-item index="cpyfw2" @click="tocpyfwjp2"
              ><span class="twoItem">鋼構造製品</span></el-menu-item
            >
            <el-menu-item index="cpyfw3" @click="tocpyfwjp3"
              ><span class="twoItem">特許技術</span></el-menu-item
            >
            <el-menu-item index="cpyfw4" @click="tocpyfwjp4"
              ><span class="twoItem">施工・据付サービス</span></el-menu-item
            >
            <el-menu-item index="cpyfw5" @click="tocpyfwjp5"
              ><span class="twoItem">工場再生可能エネルギ</span></el-menu-item
            >
          </el-submenu>

          <el-submenu index="quality" class="nav-item">
            <template slot="title"
              ><span class="oneItem">品質と安全</span></template
            >
            <el-menu-item index="pzyaq1" @click="topzyaqjp1"
              ><span class="twoItem">品質管理</span></el-menu-item
            >
            <el-menu-item index="pzyaq2" @click="topzyaqjp2"
              ><span class="twoItem">製品品質</span></el-menu-item
            >
            <el-menu-item index="pzyaq3" @click="topzyaqjp3"
              ><span class="twoItem">梱包・輸送</span></el-menu-item
            >
            <el-menu-item index="pzyaq4" @click="topzyaqjp4"
              ><span class="twoItem">安全管理</span></el-menu-item
            >
          </el-submenu>
          <el-menu-item index="gcjs" @click="togcyjjp" class="nav-item"
            ><span class="oneItem">プロジェクト実績</span></el-menu-item
          >
          <el-menu-item index="news" @click="tozxxxjp" class="nav-item"
            ><span class="oneItem">最新情報</span></el-menu-item
          >
          <!-- <el-menu-item index="language" @click="changeLan" class="language-item">
          <i class="glyphicon glyphicon-globe"></i>
          <span class="oneItem" @click="changeLan()">EN</span>
        </el-menu-item> -->
          <el-submenu index="language" class="nav-item">
            <template slot="title"><span class="oneItem">言語</span></template>
            <el-menu-item index="chinese" @click="toZh"
              ><span class="twoItem">繁体中文</span></el-menu-item
            >
            <el-menu-item index="english" @click="toEng"
              ><span class="twoItem">英語</span></el-menu-item
            >
          </el-submenu>
        </el-menu>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-nav" v-if="isMobile">
          <div class="hamburger-btn" @click="openMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <el-drawer
            :visible.sync="drawerVisible"
            direction="ltr"
            size="75%"
            :modal="true"
            :modal-append-to-body="false"
            custom-class="optimized-drawer"
            @open="lockBodyScroll"
            @close="unlockBodyScroll"
            :with-header="false"
          >
            <el-menu
              class="mobile-menu"
              :default-active="activeIndex"
              @select="handleSelect"
            >
              <el-menu-item index="home" @click="tohomejp" class="mobile-item">
                <i class="el-icon-house"></i>
                <span class="oneItem" index="/home">ホーム</span>
              </el-menu-item>

              <el-submenu index="about" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/gyhy">会社情報</span>
                </template>
                <el-menu-item index="gyhy1" @click="togyhyjp1"
                  ><span class="twoItem">沿革</span></el-menu-item
                >
                <el-menu-item index="gyhy2" @click="togyhyjp2"
                  ><span class="twoItem">企業理念</span></el-menu-item
                >
                <el-menu-item index="gyhy3" @click="togyhyjp3"
                  ><span class="twoItem">ビジョン</span></el-menu-item
                >
                <el-menu-item index="gyhy4" @click="togyhyjp4"
                  ><span class="twoItem"
                    >ESG 環境・社会・ガバナンス</span
                  ></el-menu-item
                >
                <el-menu-item index="gyhy5" @click="togyhyjp5"
                  ><span class="twoItem">工場紹介</span></el-menu-item
                >
                <el-menu-item index="gyhy6" @click="togyhyjp6"
                  ><span class="twoItem">国際認証と建築賞</span></el-menu-item
                >
              </el-submenu>

              <el-submenu index="cpyfw" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/cpyfw">技術・製品</span>
                </template>
                <el-menu-item index="cpyfw1" @click="tocpyfwjp1"
                  ><span class="twoItem"
                    >エンジニアリングサービス</span
                  ></el-menu-item
                >
                <el-menu-item index="cpyfw2" @click="tocpyfwjp2"
                  ><span class="twoItem">鋼構造製品</span></el-menu-item
                >
                <el-menu-item index="cpyfw3" @click="tocpyfwjp3"
                  ><span class="twoItem">特許技術</span></el-menu-item
                >
                <el-menu-item index="cpyfw4" @click="tocpyfwjp4"
                  ><span class="twoItem">施工・据付サービス</span></el-menu-item
                >
                <el-menu-item index="cpyfw5" @click="tocpyfwjp5"
                  ><span class="twoItem"
                    >工場再生可能エネルギ</span
                  ></el-menu-item
                >
              </el-submenu>

              <el-submenu index="pzyaq" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/pzyaq">品質と安全</span>
                </template>
                <el-menu-item index="pzyaq1" @click="topzyaqjp1"
                  ><span class="twoItem">品質管理</span></el-menu-item
                >
                <el-menu-item index="pzyaq2" @click="topzyaqjp2"
                  ><span class="twoItem">製品品質</span></el-menu-item
                >
                <el-menu-item index="pzyaq3" @click="topzyaqjp3"
                  ><span class="twoItem">梱包・輸送</span></el-menu-item
                >
                <el-menu-item index="pzyaq4" @click="topzyaqjp4"
                  ><span class="twoItem">安全管理</span></el-menu-item
                >
              </el-submenu>

              <el-menu-item index="gcyj" @click="togcyjjp" class="mobile-item">
                <i class="el-icon-notebook-2"></i>
                <span class="oneItem" index="/gcyj">プロジェクト実績</span>
              </el-menu-item>

              <el-menu-item index="zxxx" @click="tozxxxjp" class="mobile-item">
                <i class="el-icon-news"></i>
                <span class="oneItem" index="/zxxx">最新情報</span>
              </el-menu-item>

              <el-submenu index="language" class="mobile-item">
                <template slot="title">
                  <img
                    src="@/components/img/diqiu.png"
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="oneItem" index="/language">言語</span>
                </template>
                <el-menu-item index="chinese" @click="toZh"
                  ><span class="twoItem">繁体中文</span></el-menu-item
                >
                <el-menu-item index="english" @click="toEng"
                  ><span class="twoItem">English</span></el-menu-item
                >
              </el-submenu>

              <!-- <el-menu-item index="language" @click="changeLan" class="mobile-item">
              <i class="el-icon-sort"></i>
              <span class="oneItem">EN</span>
            </el-menu-item> -->

              <el-menu-item
                index="close"
                @click="drawerVisible = false"
                class="close-item"
              >
                <i class="el-icon-close"></i>
                <span class="oneItem">閉じる</span>
              </el-menu-item>
            </el-menu>
          </el-drawer>
        </div>
      </div>
    </div>
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import Loader from '../skip/Loader.vue'
export default {
  props: {
    Language: String,
  },
  data() {
    return {
      isLoading: false,
      activeIndex: 'home',
      isMobile: false,
      drawerVisible: false,
      resizeTimer: null,
    }
  },
  methods: {
    // changeLan() {
    //   this.$emit('ELchange')
    // },
    toEng() {
      this.$emit('ELchange')
    },
    toZh() {
      this.$emit('ZLchange')
    },
    handleSelect(index) {
      if (index === 'close') return
      this.activeIndex = index
      if (this.isMobile) {
        this.drawerVisible = false
      }
    },
    checkMobile() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        const wasMobile = this.isMobile
        this.isMobile = window.innerWidth < 1400

        if (wasMobile && !this.isMobile) {
          this.drawerVisible = false
        }
      }, 200)
    },
    // 首頁
    tohomejp() {
      if (this.$route.fullPath != '/homejp') {
        this.isLoading = true
        this.$router
          .push('/homejp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 關於華胤
    togyhyjp1() {
      if (this.$route.fullPath != '/gyhyjp') {
        this.isLoading = true
        this.$router
          .push('/gyhyjp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyjp2() {
      if (this.$route.fullPath != '/gyhyjp#hymb') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyjp',
            hash: '#hymb',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyjp3() {
      if (this.$route.fullPath != '/gyhyjp#hyyj') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyjp',
            hash: '#hyyj',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyjp4() {
      if (this.$route.fullPath != '/gyhyjp#esg') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyjp',
            hash: '#esg',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyjp5() {
      if (this.$route.fullPath != '/gyhyjp#gcjs') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyjp',
            hash: '#gcjs',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhyjp6() {
      if (this.$route.fullPath != '/gyhyjp#rzjx') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhyjp',
            hash: '#rzjx',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 产品与服务
    tocpyfwjp1() {
      if (this.$route.fullPath != '/cpyfwjp') {
        this.isLoading = true
        this.$router
          .push('/cpyfwjp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwjp2() {
      if (this.$route.fullPath != '/cpyfwjp#xtcp') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwjp',
            hash: '#xtcp',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwjp3() {
      if (this.$route.fullPath != '/cpyfwjp#hyzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwjp',
            hash: '#hyzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwjp4() {
      if (this.$route.fullPath != '/cpyfwjp#azfw') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwjp',
            hash: '#azfw',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfwjp5() {
      if (this.$route.fullPath != '/cpyfwjp#gsxny') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfwjp',
            hash: '#gsxny',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 品质与安全
    topzyaqjp1() {
      if (this.$route.fullPath != '/pzyaqjp') {
        this.isLoading = true
        this.$router
          .push('/pzyaqjp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqjp2() {
      if (this.$route.fullPath != '/pzyaqjp#cpzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqjp',
            hash: '#cpzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqjp3() {
      if (this.$route.fullPath != '/pzyaqjp#cpbz') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqjp',
            hash: '#cpbz',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaqjp4() {
      if (this.$route.fullPath != '/pzyaqjp#aqzc') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaqjp',
            hash: '#aqzc',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 工程业绩
    togcyjjp() {
      if (this.$route.fullPath != '/gcyjjp') {
        this.isLoading = true
        this.$router
          .push('/gcyjjp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 最新消息
    tozxxxjp() {
      if (this.$route.fullPath != '/zxxxjp') {
        this.isLoading = true
        this.$router
          .push('/zxxxjp')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },

    openMobileMenu() {
      this.drawerVisible = true
    },
    lockBodyScroll() {
      document.body.classList.add('mobile-nav-open')
      document.addEventListener('wheel', this.preventScroll, { passive: false })
    },
    unlockBodyScroll() {
      document.body.classList.remove('mobile-nav-open')
      document.removeEventListener('wheel', this.preventScroll)
    },
    preventScroll(e) {
      if (this.drawerVisible) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    clearTimeout(this.resizeTimer)
  },
  components: {
    Loader,
  },
}
</script>

<style scoped>
.toTop {
  width: 100%;
  height: 80px;
}
.all-header {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100vw;
  max-width: 100vw;
  background-color: #fff;
  border-bottom: 1px solid #8b8b8b;
}
.final-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 84px;
  position: relative;
  z-index: 1000;
  width: 95vw;
  margin: 0 auto;
}

.nav-logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 75px;
  width: auto;
}

.desktop-nav {
  border-bottom: none;
  display: flex;
  align-items: center;
  height: 80px;
}

/* 桌面版菜单项与分割线 */
.nav-item {
  position: relative;
  padding: 0 20px;
}
.nav-item:not(:last-child):after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  width: 1px;
  background-color: #e6e6e6;
}

.language-item i {
  margin-right: 5px;
}

/* 移动端三横线按钮 */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 14px;
  cursor: pointer;
}
.hamburger-btn span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #333;
  transition: all 0.3s;
}

/* 移动端菜单样式 */
.optimized-drawer {
  pointer-events: none;
}

.optimized-drawer .el-drawer__container {
  pointer-events: auto;
}

.optimized-drawer .el-drawer__mask {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.3);
}
.mobile-menu {
  border-right: none;
  padding-top: 10px;
}

/* 移动端菜单项与分割线 */
.mobile-item {
  border-bottom: 1px solid #f5f5f5;
}
.mobile-item:last-child {
  border-bottom: none;
}

.close-item {
  margin-top: 10px;
  border-top: 1px solid #e6e6e6;
}

.oneItem {
  font-size: 20px;
  font-weight: bolder;
}
.twoItem {
  font-size: 16px;
  font-weight: 400;
  margin: 10px 0;
}
div /deep/ .el-submenu__title {
  padding: 0;
}

/* 响应式断点 */
@media (max-width: 1400px) {
  .toTop {
    width: 100%;
    height: 80px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 80px;
    width: 98vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 60px;
  }
  .oneItem {
    font-size: 17px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 16px;
    font-weight: normal;
  }
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 19px;
    cursor: pointer;
  }
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

/* 响应式断点 */
@media (max-width: 767px) {
  .toTop {
    width: 100%;
    height: 56px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 56px;
    width: 100vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 42px;
  }
  .oneItem {
    font-size: 14px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 13px;
    font-weight: normal;
  }
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 20px;
    height: 14px;
    cursor: pointer;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

.el-menu--horizontal .el-menu--popup {
  padding: 5px 0;
}
.el-menu--horizontal .el-menu--popup .el-menu-item {
  height: 40px;
  line-height: 40px;
  transition: all 0.2s;
  border-top: 1px solid #f5f5f5;
}
.el-menu--horizontal .el-menu--popup .el-menu-item:first-child {
  border-top: 6px solid #404040;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background: rgb(96, 96, 96);
}
.el-menu--horizontal .el-menu--popup .el-menu-item:hover .twoItem {
  color: #fff;
  transform: translateX(3px);
}

/* 移动版 */
.mobile-menu .el-menu-item {
  transition: all 0.3s;
}
.mobile-menu .el-menu-item:hover {
  background: var(--hover-bg-color);
}
.mobile-menu .el-menu-item:hover .twoItem {
  color: green;
}

@media (min-width: 1400px) {
  .mobile-nav {
    display: none;
  }
}
@media (min-width: 2000px) {
  .oneItem {
    font-size: 25px;
  }
  .twoItem {
    font-size: 19px;
  }
  .logo-img {
    height: 80px;
  }
  .el-menu--horizontal .el-menu--popup .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
}
</style>
